import request from '@/utils/request'

export function bottomTableByPc(data) {
  return request({
    url: '/promotion/bottomTableByPc',
    method: 'post',
    data: data
  })
}
export function middleTableByPc(data) {
  return request({
    url: '/promotion/middleTableByPc',
    method: 'post',
    data: data
  })
}
export function topTableByPc(data) {
  return request({
    url: '/promotion/topTableByPc',
    method: 'post',
    data: data
  })
}

export function getSelectParma() {
  return request({
    url: '/promotion/getSelectParma',
    method: 'get'
  })
}

export function kickbackManager(data) {
  return request({
    url: '/promotion/kickbackManager',
    method: 'post',
    data: data
  })
}

export function getDetail(data) {
  return request({
    url: '/promotion/getMyKickbackDetail',
    method: 'post',
    data: data
  })
}
// 推广专员管理-详情
export function promotionManagerDetail(data) {
  return request({
    url: '/promotion/promotionManagerDetail',
    method: 'post',
    data: data
  })
}

// 新增退货订单
export function promotionManager(data) {
  return request({
    url: '/promotion/promotionManager',
    method: 'post',
    data: data
  })
}
// 查询退货订单列表
export function getUserPromotionResult(query) {
  return request({
    url: '/promotion/getUserPromotionResult',
    method: 'get'
  })
}
export function aa(query) {
  return request({
    url: '/promotion/getUserPromotionResult',
    method: 'get',
    params: query
  })
}
// 新增退货订单
export function addUserPromotion(data) {
  return request({
    url: '/promotion/addUserPromotion',
    method: 'post',
    data: data
  })
}
